const styleSeparator =
  "border-top: 1px dashed; margin-top:0.1cm; margin-bottom:0.1cm;";
const styleSeparatorRight =
  "border-top: 1px dashed; margin-top:0.1cm; margin-bottom:0.1cm; width: 50%; margin-left: auto; margin-right: 0;";

const generateDeliveryInvoiceHTML = (sale, ctxPrinting, imageLogo) => {
  const lines = sale?.lines || [];

  const INVOICE_TYPE = {
    P: "SISTEMA POS:",
    1: "FACTURA DE VENTA ELECTRONICA:",
    M: "CORTESIA:",
  };

  const number = sale?.number || sale?.order || "";
  const title = sale?.number ? (INVOICE_TYPE[sale?.invoice_type] ?? "FACTURA DE VENTA:") : "PEDIDO:";

  const logoSrc = ctxPrinting?.company_logo
    ? `data:image/jpeg;base64,${ctxPrinting.company_logo}`
    : imageLogo || "";

  let createDateObj = null;
  if (sale.create_date) {
    const [datePart, timePart, meridian] = sale.create_date.split(" ");
    const [day, month, year] = datePart.split("/");
    let [hour, minute] = timePart.split(":");
    hour = parseInt(hour, 10);
    if (hour <= 12) {
      if (meridian === "PM" && hour !== 12) hour += 12;
      if (meridian === "AM" && hour === 12) hour = 0;
    }
    createDateObj = new Date(year, month - 1, day, hour, minute);
  }

  const saleDate =
    createDateObj && !Number.isNaN(createDateObj)
      ? createDateObj.toLocaleDateString("es-CO")
      : "";

  const saleTime =
    createDateObj && !Number.isNaN(createDateObj)
      ? createDateObj.toLocaleTimeString("es-CO", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "";

  const printDate = new Date().toLocaleString("es-CO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const linesHTML = lines
    .map((item) => {
      if (item.parent) return "";
      const subtotal = Math.round(item.amount_w_tax || 0).toLocaleString(
        "es-CO",
      );
      return `
        <div style="display: flex; justify-content: space-between; margin-bottom: 0.1cm;">
          <div style="width: 70%;">${item.name || item.product?.name || ""}</div>
          <div style="width: 30%; text-align: right;">${subtotal}</div>
        </div>`;
    })
    .join("");

  // Detalle de impuestos
  const taxes = sale?.taxes ?? {};
  let taxesHtml = `
    <div style="display: flex; justify-content: space-between; margin-bottom: 0.1cm;">
      <div style="width: 40%;"><b>Tipo</b></div>
      <div style="width: 30%; text-align: right;"><b>Base</b></div>
      <div style="width: 30%; text-align: right;"><b>Imp.</b></div>
    </div>`;

  if (Object.keys(taxes).length > 0) {
    Object.values(taxes).forEach(({ name, base, tax }) => {
      taxesHtml += `
        <div style="display: flex; justify-content: space-between; border-bottom: 1px dashed;">
          <div style="width: 40%;">${name}</div>
          <div style="width: 30%; text-align: right;">${parseInt(base || 0, 10).toLocaleString("es-CO")}</div>
          <div style="width: 30%; text-align: right;">${parseInt(tax || 0, 10).toLocaleString("es-CO")}</div>
        </div>`;
    });
  }

  // Medios de pago
  const paymentsHTML = sale?.payments?.length
    ? `<div style="margin-top: 0.3cm; border-top: 1px dashed; border-bottom: 1px dashed; padding: 0.2cm 0;">
        <div><b>MEDIO PAGO</b></div>
        <div style="display: flex; justify-content: space-between; font-size: 2.4mm; color: #555;">
          <div style="width: 35%;">Tipo</div>
          <div style="width: 30%; text-align: center;">Aprob</div>
          <div style="width: 35%; text-align: right;">Valor</div>
        </div>
        ${sale.payments
          .map(
            (p) => `
          <div style="display: flex; justify-content: space-between;">
            <div style="width: 35%;">${p.name || ""}</div>
            <div style="width: 30%; text-align: center;">${p.voucher || "--"}</div>
            <div style="width: 35%; text-align: right;">${Math.round(p.amount || 0).toLocaleString("es-CO")}</div>
          </div>`,
          )
          .join("")}
      </div>`
    : "";

  const consumer = sale.consumer || null;

  const consumerHTML = consumer
    ? `<div style="margin: 0.3cm 0; padding: 0.2cm 0;">
        <div style="text-align:center; font-weight:bold; margin-bottom:0.2cm;">======= INFO CONSUMIDOR =======</div>
        ${consumer.consumer_name ? `<div style="font-weight:bold">NOMBRE: ${consumer.consumer_name}</div>` : ""}
        ${consumer.consumer_address ? `<div style="font-weight:bold">DIRECCION: ${consumer.consumer_address}</div>` : ""}
        ${consumer.consumer_phone ? `<div style="font-weight:bold">TELEFONO: ${consumer.consumer_phone}</div>` : ""}
        ${
          sale.payment_method
            ? `<div style="font-weight:bold">MEDIO DE PAGO: - ${sale.payment_method}</div>`
            : ""
        }
        ${
          sale.comment
            ? `<div style="margin-top:0.2cm;">NOTAS: ${sale.comment}</div>`
            : ""
        }
      </div>`
    : "";

  // Autorización
  const auth = ctxPrinting?.authorizations?.[sale?.invoice_type];
  const authHTML = auth
    ? `<div style="margin-top: 0.2cm; font-size: 2.8mm;">
        Autorizacion de facturacion ${auth.kind || ""} No ${auth.number || ""}
        del ${auth.start_date_auth || ""} hasta ${auth.end_date_auth || ""},
        habilita desde ${auth.prefix || ""}${auth.from_auth || ""}
        a ${auth.prefix || ""}${auth.to_auth || ""}
      </div>`
    : "";

  const valorNeto = Math.round(
    (sale.total_amount || 0) + (sale.delivery_amount || 0),
  );

  const html = `
    <div style="width: 68mm; padding: 0.1cm; font-family: monospace; font-size: 2.8mm; box-sizing: border-box;">

      <div style="text-align: center; margin-bottom: 0.5cm">
        <div style="margin-bottom: 0.5cm">
         ${logoSrc ? `<center><img src="${logoSrc}" width="60%"></center>` : ""}
        </div>
        <div>${ctxPrinting.company}</div>
        <div>${ctxPrinting.shop}</div>
        <div>NIT: ${ctxPrinting.id_number} ${ctxPrinting.regime_tax}</div>
        <div>${ctxPrinting.street}</div>
        <div>${ctxPrinting.city} Telefono: ${ctxPrinting.phone}</div>
      </div>

      <div>
        <div>${title} ${number}</div>
        <div style="display: flex; justify-content: space-between;">
          <div>Fecha: ${saleDate}</div>
          <div>Hora: ${saleTime}</div>
        </div>
        ${sale.turn ? `<div>Turno: ${sale.turn}</div>` : ""}
      </div>
      <div style="${styleSeparator}"></div>

      <div>
        <div>Cliente: ${sale.party || ""}</div>
        <div>Id: ${sale.party_id_number || ""}</div>
        <div>Direccion: ${sale.party_address || ""}</div>
        <div>Forma de Pago: ${sale.payment_term || ""}</div>
        <div>Servicio: Domicilio</div>
        ${
          sale.delivery_party
            ? `<div>Domiciliario: ${sale.delivery_party}</div>`
            : ""
        }
      </div>

      ${consumerHTML}

      <div style="display: flex; justify-content: space-between; border-top: 1px dashed; border-bottom: 1px dashed; margin-top: 0.4cm; margin-bottom: 0.3cm; padding: 0.2cm 0;">
        <div style="width: 70%;"><b>Articulo</b></div>
        <div style="width: 30%; text-align: right;"><b>Subtotal</b></div>
      </div>
      ${linesHTML}

      <div style="${styleSeparatorRight}"></div>

      <div style="display: flex; justify-content: space-between;">
        <div>Subtotal Base:</div>
        <div>${Math.round(sale.untaxed_amount || 0).toLocaleString("es-CO")}</div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div>Impuesto:</div>
        <div>${Math.round(sale.tax_amount || 0).toLocaleString("es-CO")}</div>
      </div>
      <div style="${styleSeparatorRight}"></div>
      <div style="display: flex; justify-content: space-between;">
        <div>Total:</div>
        <div>${Math.round(sale.total_amount || 0).toLocaleString("es-CO")}</div>
      </div>
      ${
        sale.delivery_amount
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Domicilio:</div>
            <div>${Math.round(sale.delivery_amount).toLocaleString("es-CO")}</div>
          </div>`
          : ""
      }
      ${
        sale.tip_amount
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Propina:</div>
            <div>${Math.round(sale.tip_amount).toLocaleString("es-CO")}</div>
          </div>`
          : ""
      }
      <div style="${styleSeparator}"></div>
      <div style="display: flex; justify-content: space-between;">
        <div style="font-weight: bold;">Valor Neto:</div>
        <div style="font-weight: bold;">${valorNeto.toLocaleString("es-CO")}</div>
      </div>
      <div style="${styleSeparator}"></div>

      <div style="display: flex; justify-content: space-between; margin-top: 0.2cm;">
        <div>Recibido:</div>
        <div>${Math.round(sale.paid_amount || 0).toLocaleString("es-CO")}</div>
      </div>
      ${
        sale.paid_amount !== sale.total_amount
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Saldo:</div>
            <div>${Math.round(sale.residual_amount || 0).toLocaleString("es-CO")}</div>
          </div>`
          : ""
      }

      <div style="margin-top: 0.2cm;">
        <div><b>CODIGO: ${sale.order || ""}</b></div>
      </div>

      <div style="border-top: 1px dashed; margin-top: 0.3cm; padding-top: 0.1cm;">
        <div><b>DETALLE DE IMPUESTOS</b></div>
      </div>
      ${taxesHtml}

      ${paymentsHTML}

      <div>No ITEMS: ${lines.filter((l) => !l.parent).length}</div>
      <div>Caja No. ${ctxPrinting.sale_device}</div>
      ${
        ctxPrinting.cashier
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Cajero:</div><div>${ctxPrinting.cashier}</div>
          </div>`
          : ""
      }
      ${
        ctxPrinting.seller
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Vendedor:</div><div>${ctxPrinting.seller}</div>
          </div>`
          : ""
      }
      ${
        sale.table
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Mesa:</div><div>${sale.table}</div>
          </div>`
          : ""
      }
      ${
        sale.delivery_time
          ? `<div style="display: flex; justify-content: space-between;">
            <div>Hora entrega:</div><div>${sale.delivery_time}</div>
          </div>`
          : ""
      }

      <div style="${styleSeparator}"></div>

      ${authHTML}
      <div style="width: 100%; word-break: break-all;">Fecha de creacion: ${sale.create_date || ""}</div>

      <div style="${styleSeparator}"></div>

      <div style="margin: 0 0 0.3cm 0; text-align: center; font-weight: bold;">¡Gracias por su compra!</div>

      <div>SISTEMA POS</div>
      <div>PROVEEDOR DE SOFTWARE: PRESIK SAS</div>
      <div>NIT: 900803782-2</div>
      <div>SOFTWARE PRESIK - www.presik.com</div>
      <div>fecha impresion: ${printDate}</div>
    </div>
  `;

  return html;
};

let trustedHtmlPolicy = {
  createHTML: (html) => html, // Fallback si Trusted Types no está soportado
};

if (window?.trustedTypes.createPolicy) {
  // Creamos una política específica para la vista previa de impresión
  trustedHtmlPolicy = window.trustedTypes.createPolicy("printPreviewPolicy", {
    createHTML: (string) => {
      return string;
    },
  });
}

async function getRenderDocument(htmlContent) {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Factura</title>
    </head>
    <body>
      ${htmlContent}
    </body>
    </html>
    `;
  const safeHtml = trustedHtmlPolicy.createHTML(html);
  const blob = new Blob([safeHtml], {
    type: "text/html",
  });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, "", "width=500,height=700");

  return printWindow;
}

export { generateDeliveryInvoiceHTML, getRenderDocument };
